import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, timer } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class NetworkSyncService {

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) {
    }

  public startNetworkSync(serviceId: number, controllerPath: string, delay?: number): Observable<number> {
    const data = { serviceId, delay };
    return this.http.post<any>(`${getUrl()}network-sync`, data, this.requestOptionsAuthenticated());
      /*.pipe(       
        mergeMap(result => {
          this.mqttService.connect();
          timer(30000 + delay * 1000).subscribe(() => {
            this.mqttService.disconnect();
          });
          return this.mqttService.observe(result.topic);
      }),
        mergeMap((message: IMqttMessage) => {
          this.mqttService.disconnect();

          const messageJson = JSON.parse(message.payload.toString());
          return of(messageJson.date);
      }));*/
  }

  public scheduleNetworkSync(serviceId: number, controllerPath: string, timeZone: string, scheduleDate: string, scheduleTime: string) {
    const data = { serviceId, timeZone, scheduleDate, scheduleTime, controllerPath };

    return this.http.post<any>(`${getUrl()}network-sync/schedule`, data, this.requestOptionsAuthenticated());
  }

  public testBrokerConnection(): Observable<any> {
    return this.http.get<any>(`${getUrl()}mqtt/test`, this.requestOptionsAuthenticated());
  }

  public publishMessage(serviceId: number, publishDurationMinutes: number): Observable<any> {
    const data = { serviceId, publishDurationMinutes };
    return this.http.post<any>(`${getUrl()}network-sync/publish`, data, this.requestOptionsAuthenticated());
  }


  private requestOptionsAuthenticated() {
    const requestOptions = {
        headers: new HttpHeaders()
            .set('Content-type', 'application/json')
            .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken('portal')),
    };
    return requestOptions;
}
}

